import { render, staticRenderFns } from "./DisableNotifications.vue?vue&type=template&id=4cbb5816&"
import script from "./DisableNotifications.vue?vue&type=script&lang=js&"
export * from "./DisableNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports